import { JwtToken } from './jwt';
import { ADMINISTRATOR_ROLE_ID } from './constants';

export function jwtToken(context: any): JwtToken {
  return context?.jwtToken ?? {};
}

export function userId(context: any): number {
  return jwtToken(context).userId;
}

export function userName(context: any): String {
  return jwtToken(context)?.userName ?? 'uknown';
}

export function userIsAdmin(context: any): Boolean {
  const jwt = jwtToken(context);
  const hasAdmin = jwt.userRolesIds?.filter((v) => v.userroleId === ADMINISTRATOR_ROLE_ID);
  return hasAdmin && hasAdmin.length > 0;
}
